import React from 'react';
interface BonusCardProps {
  image: string;
  title: string;
  onClick: () => void;
}
export function BonusCard({
  image,
  title,
  onClick
}: BonusCardProps) {
  return <div className="flex flex-col items-center cursor-pointer transform transition-transform hover:scale-105" onClick={onClick} data-id="element-1">
      <div className="relative w-full aspect-[3/4] rounded-lg overflow-hidden shadow-lg mb-4" data-id="element-2">
        <img src={image} alt={title} className="w-full h-full object-cover" data-id="element-3" />
      </div>
      <p className="text-sm font-semibold text-gray-600 uppercase tracking-wide text-center" data-id="element-4">
        {title}
      </p>
    </div>;
}